<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <el-input type="text"
                 name="name"
                 placeholder="Name"
                 @blur="generateKey"
                 clearable
                 v-model="edit.name"
                 v-validate="modelValidations.name" />
          <small class="text-danger" v-show="errors.has('name')">
            {{ getError('name') }}
          </small>
        </div>
        <div class="form-group">
          <label>Key</label>
          <el-input type="text"
                 name="key"
                 placeholder="Key"
                 v-model="edit.key"
                 v-validate="modelValidations.key"
                 clearable/>
          <small class="text-danger" v-show="errors.has('key')">
            {{ getError('key') }}
          </small>
        </div>
        <div class="form-group">
          <label>Task Template</label>
          <v-select
            v-model="selectedTaskTemplate"
            @input="setTaskTemplate"
            placeholder="Task Template"
            label="label"
            code="value"
            :options="taskTemplates">
          </v-select>
          <small class="text-danger" v-show="errors.has('taskTemplateId')">
            {{ getError('taskTemplateId') }}
          </small>
        </div>
        <div class="form-group">
          <label>Departments</label>
          <el-select multiple class="select"
                     size="large"
                     name="departments"
                     data-vv-as="departments"
                     placeholder="Departments"
                     v-model="edit.departments"
                     v-validate="modelValidations.departments">
            <el-option v-for="option in allDepartments"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="errors.has('departments')">
            {{ getError('departments') }}
          </small>
        </div>
        <div class="form-group row">
          <div class="col-md-3">
            <label>Repeatable</label>
            <p-switch v-model="edit.repeatable" type="primary" on-text="YES" off-text="NO" style="display:block"></p-switch>
          </div>
          <div class="col-md-3">
            <label>Invoiceable</label>
            <p-switch v-model="edit.invoiceable" type="primary" on-text="YES" off-text="NO" style="display:block"></p-switch>
          </div>
          <div class="col-md-6">
            <div v-if="edit.invoiceable">
              <label>
                QuickBooks Item Code
                <el-tooltip effect="dark" content="Please select a department to see Item Codes" placement="top">
                  <img class="icon-help" src="static/img/icon-help.png"/>
                </el-tooltip>
              </label>
              <v-select
                v-model="selectedQbItemCode"
                v-validate="edit.invoiceable ? 'required' : ''"
                name="qbItemCode"
                @input="setQbItemCode"
                placeholder="Item Code"
                data-vv-as="QuickBooks item code"
                label="label"
                value="value"
                :options="itemCodes">
              </v-select>
              <small class="text-danger" v-show="errors.has('qbItemCode')">
                {{ getError('qbItemCode') }}
              </small>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-4" style="padding-top:20px"><h6>PDF Forms</h6></div>
            <div class="col-md-4"><button type="button" @click="uploadForms" class="btn btn-fill btn-info btn-add-form pull-right">Upload PDF Form(s)</button></div>
            <div class="col-md-4"><button type="button" @click="toggleSearchForm" class="btn btn-fill btn-info btn-add-form pull-right">Associate PDF Form</button></div>
          </div>
          <div v-if="showFormSearch" class="form-search">
            <el-autocomplete
              style="width:100%"
              name="formToAdd"
              class="inline-input"
              :clearable="true"
              v-model="formToAdd"
              v-validate="modelValidations.formToAdd"
              :fetch-suggestions="findPdfForms"
              :trigger-on-focus="false"
              value-key="name"
              placeholder="PDF Form Name"
              @select="appendPdfForm">
            </el-autocomplete>
          </div>
          <el-table id="forms-table"
                    class="table-striped"
                    :data="files"
                    row-class-name="draggable"
                    row-key="label"
                    border
                    style="width: 100%">
            <el-table-column label="Forms">
              <template slot-scope="props">
                {{ props.row.name }}
              </template>
            </el-table-column>
            <el-table-column
              width="100"
              fixed="right"
              label="Actions">
              <template slot-scope="props">
                <div style="text-align:center">
                  <p-button type="danger" size="sm" icon @click="removePdfForm(props.row)">
                    <i class="fa fa-times"></i>
                  </p-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-6" style="padding-top:20px"><h6>Form Field Blocks</h6></div>
            <div class="col-md-6"><button type="button" @click="toggleFormFieldBlockSearchForm" class="btn btn-fill btn-info btn-add-form pull-right">Associate Form Field Block</button></div>
          </div>
          <div v-if="showFormFieldBlockFormSearch" class="form-search">
            <el-autocomplete
              style="width:100%"
              name="formFieldBlockToAdd"
              class="inline-input"
              :clearable="true"
              v-model="formFieldBlockToAdd"
              :fetch-suggestions="findFormFieldBlocks"
              :trigger-on-focus="false"
              value-key="name"
              placeholder="Form Field Block"
              @select="appendFormFieldBlock">
            </el-autocomplete>
          </div>
          <el-table id="form-field-blocks-table" class="table-striped"
                    :data="formFieldBlocks"
                    row-key="name"
                    row-class-name="draggable"
                    border
                    style="width: 100%">
            <el-table-column label="Form Field Blocks">
              <template slot-scope="props">
                {{ formFormFieldBlockName(props.row.formFieldBlockId) }}
              </template>
            </el-table-column>
            <el-table-column
              width="100"
              fixed="right"
              label="Actions">
              <template slot-scope="props">
                <div style="text-align:center">
                  <p-button type="danger" size="sm" icon @click="removeFormFieldBlock(props.row)">
                    <i class="fa fa-times"></i>
                  </p-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="row" style="margin-top: 15px">
          <div class="col-md-12">
            <button v-if="!hasData" type="button" @click="importTaskName" class="btn btn-fill btn-info btn-wd">Import</button>
            <button v-if="hasData" type="button" @click="exportTaskName" class="btn btn-fill btn-info btn-wd">Export</button>
            <button type="submit" :disabled="isSubmitDisabled" @click.prevent="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save Task Name</button>
            <div class="form-group form-group-active-label">
              <label class="active-label">Active</label>
              <p-switch v-model="edit.active" type="primary" on-text="YES" off-text="NO"></p-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  autocompleteReady,
  clearLocalStorage,
  kvpsForSelectTheWorks,
  notifyError,
  notifySuccess,
  objectBy,
  sortableTable,
  sortBySort
} from '@/utilities/utils'
import PButton from '@/components/UIComponents/Button.vue'
import PSwitch from '@/components/UIComponents/Switch.vue'
import Constants from '@/utilities/constants'
import {get, sync} from 'vuex-pathify'
import {mapGetters} from 'vuex'
import {OK} from 'http-status-codes'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import _ from 'lodash'
import {ptracGetEntities} from "@/utilities/ptracApi";

export default {
  props: ['data'],
  components: {
    PButton,
    PSwitch,
    vSelect
  },
  data() {
    return {
      isProcessing: false,
      showFormSearch: false,
      showFormFieldBlockFormSearch: false,
      formToAdd: null,
      formFieldBlockToAdd: null,
      selectedTaskTemplate: null,
      selectedQbItemCode: null,
      modelValidations: {
        name: {
          required: true,
          max: 128
        },
        key: {
          required: true,
          max: 128
        },
        taskTemplateId: {
          required: true
        },
        departments: {
          required: true
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      allItemCodes: 'quickbooks/results',
      taskNamesForSelect: 'tasks/names/kvpsForSelect',
      taskTemplates: 'tasks/templates/kvpsForSelect',
      allDepartments: 'departments/kvpsForSelect',
      pdfFormsAutoCompleteResults: 'files/inspectionForms/autocompleteResults',
      formFieldBlocksAutoCompleteResults: 'inspectorApp/formFieldBlocks/autocompleteResults'
    }),
    edit: sync('tasks/names@edit'),
    ...get('tasks/names@edit', [
      'files',
      'formFieldBlocks'
    ]),
    itemCodes() {
      if (Array.isArray(this.edit.departments)) {
        const filteredICs = _.filter(this.allItemCodes, (itemCode) => this.edit.departments.includes(itemCode.departmentId))
        return kvpsForSelectTheWorks(filteredICs, {
          sortBy: 'name',
          labelProp: 'name',
          valueProp: 'id',
          extraValue: 'qbClass'
        })
      }
      return []
    },
    hasData() {
      return !!this.data
    },
    isSubmitDisabled() {
      return this.isProcessing
    }
  },
  methods: {
    uploadForms() {
      this.$eventHub.$emit('show-modal-2', 'Upload Forms',
        {
          folder: Constants.FOLDERS.INSPECTION_FORMS
        }, '500px')
    },
    maybeSetSelectedQbItemCode() {
      if (this.edit.qbItemCodeId) {
        const qbItemCode = objectBy(this.itemCodes, 'value', this.edit.qbItemCodeId)

        if (!qbItemCode) {
          console.error('Expected QB item code not found by ID: ' + this.edit.qbItemCodeId)
          return
        }

        this.selectedQbItemCode = qbItemCode.label
      }
    },
    setQbItemCode(qbItemCode) {
      this.$store.set('tasks/names/edit@qbItemCodeId', null)
      if (qbItemCode) {
        this.$store.set('tasks/names/edit@qbItemCodeId', qbItemCode.value)
      }
    },
    setTaskTemplate(taskTemplate) {
      this.$store.set('tasks/names/edit@taskTemplateId', null)
      if (taskTemplate) {
        this.$store.set('tasks/names/edit@taskTemplateId', taskTemplate.value)
      }
    },
    generateKey() {
      this.$store.commit('tasks/names/generateKey')
    },
    async findPdfForms(text, cb) {
      if (autocompleteReady(text)) {
        await this.$store.dispatch('files/inspectionForms/fileNameStartsWith', text)
        cb(this.pdfFormsAutoCompleteResults)
      }
    },
    appendPdfForm(file) {
      if (file) {
        this.$store.commit('tasks/names/appendPdfForm', file)
      }
      this.formToAdd = ''
    },
    async findFormFieldBlocks(text, cb) {
      if (autocompleteReady(text)) {
        await this.$store.dispatch('inspectorApp/formFieldBlocks/fetchAutoCompleteResults', text)
        cb(this.formFieldBlocksAutoCompleteResults)
      }
    },
    appendFormFieldBlock(formFieldBlock) {
      if (formFieldBlock) {
        this.$store.commit('tasks/names/appendFormFieldBlock', formFieldBlock)
      }
      this.formFieldBlockToAdd = ''
    },
    removeFormFieldBlock(formFieldBlock) {
      if (formFieldBlock) {
        this.$store.commit('tasks/names/removeFormFieldBlock', formFieldBlock)
      }
    },
    formFormFieldBlockName(id) {
      const formFieldBlock = this.$store.get('inspectorApp/formFieldBlocks/byId', id)

      if (formFieldBlock) {
        return formFieldBlock.name
      }

      return ''
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    async validateAndSubmit() {
      this.isProcessing = true

      if (await this.$validator.validateAll()) {
        const response = await this.$store.dispatch('save', {
          endpoint: 'task-names',
          data: this.edit
        })

        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          this.$store.commit('tasks/names/resetEdit')
          this.clearCacheLocalStorage()
          notifySuccess(this, 'Task Name Saved Successfully')
          this.$eventHub.$emit('taskNameSaved')
          this.$emit('close')
        } else {
          notifyError(this, 'Failed to Save Task Name', response.errors)
        }
      }
      this.isProcessing = false
    },
    toggleSearchForm() {
      this.showFormSearch = !this.showFormSearch
    },
    toggleFormFieldBlockSearchForm() {
      this.showFormFieldBlockFormSearch = !this.showFormFieldBlockFormSearch
    },
    removePdfForm(file) {
      this.$store.commit('tasks/names/removePdfForm', file)
    },
    maybeSetSelectTaskTemplate(taskTemplateId) {
      const taskTemplate = objectBy(this.taskTemplates, 'value', taskTemplateId)
      if (taskTemplate) {
        this.selectedTaskTemplate = taskTemplate.label
      }
    },
    clearCacheLocalStorage() {
      // purge the task names cache after a task name has been added or edited
      if (this.$store.cache.has('tasks/names/fetchAll')) {
        this.$store.cache.delete('tasks/names/fetchAll')
      }
      clearLocalStorage(Constants.LOCAL_STORAGE.LOCATION.TASK_NAMES)
    },
    associateFormsWithTaskName(files) {
      if (Array.isArray(files) && files.length > 0) {
        files.forEach((file) => {
          this.appendPdfForm(file)
        })
      }
    },
    loadFormFieldBlockSortableTable() {
      sortableTable('#form-field-blocks-table .el-table__body-wrapper tbody', this.updateFormFieldBlocksSort)
    },
    loadFormsSortableTable() {
      sortableTable('#forms-table .el-table__body-wrapper tbody', this.updateFormsSort)
    },
    updateFormFieldBlocksSort(sortedFields) {
      this.$store.commit('tasks/names/updateFormFieldBlocksSort', sortedFields)
    },
    updateFormsSort(sortedFields) {
      this.$store.commit('tasks/names/updateFormsSort', sortedFields)
    },
    importTaskName() {
      this.$eventHub.$emit('show-modal-1', 'Import Task Name', null, '700px')
    },
    exportTaskName() {
      this.$eventHub.$emit('show-modal-2', 'Export Task Name', this.data, '600px')
    }
  },
  async beforeMount() {
    await this.$store.cache.dispatch('quickbooks/fetchAll')
  },
  async mounted() {
    this.$validator.pause()
    this.$store.commit('tasks/names/resetEdit')
    await this.$store.cache.dispatch('tasks/templates/fetchAll')
    if (this.data) {
      // load a fresh instance from the API
      const response = await this.$store.dispatch('fetchById', {
        'endpoint': 'task-names',
        'id': this.data.id
      })

      if (OK !== response.status) {
        notifyError(this, "Failed to load task name by ID: " + this.data.id)
        return
      }

      const taskName = response.data
      if (taskName.formFieldBlocks) {
        taskName.formFieldBlocks.forEach((formFieldBlock) => {
          formFieldBlock.name = this.formFormFieldBlockName(formFieldBlock.formFieldBlockId)
        })
        taskName.formFieldBlocks = sortBySort(taskName.formFieldBlocks)
      }
      if (taskName.files) {
        const fileIds = _.map(taskName.files, 'fileId')
        const filesResponse = await ptracGetEntities(`files/search/findByIdIn?ids=${fileIds.join()}&sort=name,asc`, 'ptracFiles')

        if (OK === filesResponse.status) {
          taskName.files = sortBySort(_.filter(taskName.files, file =>
            _.some(filesResponse.data, responseFile => responseFile.id === file.fileId)
          ))
        }
      }
      this.$store.commit('tasks/names/hydrateEdit', taskName)
      this.maybeSetSelectTaskTemplate(taskName.taskTemplateId)
      this.loadFormFieldBlockSortableTable()
      this.loadFormsSortableTable()
    }
    this.$validator.resume()
    this.maybeSetSelectedQbItemCode()

    this.$eventHub.$on('inspectionFormUploaded', this.associateFormsWithTaskName)
  },
  destroyed() {
    this.$eventHub.$off('inspectionFormUploaded')
  }
}
</script>

<style scoped>
  label {
    display: block;
  }
  .task-field .select {
    width: 100%;
  }
  .btn-add-form {
    margin-bottom: 12px;
  }
  .form-search {
    margin-bottom: 6px;
  }
</style>
